import React from "react";
import {
  ExcursionActivityLevelIcon,
  ExcursionInfoBox,
  ExcursionInfoBoxItem,
  IconName
} from "@silversea-ssc/ui-components-react";

import { Plural, Trans, useLingui } from "@lingui/react/macro";
import {
  SanityMicroContentExcursionsAccessibilityLevel,
  SanityMicroContentExcursionsActivityLevel,
  SanityMicroContentExcursionsFeature
} from "../use-sanity-shorex-content";

type ContentExcursionInfoBoxProps = {
  duration: number | undefined;
  hideDurationAndCode: boolean;
  accessibilityLevel:
    | SanityMicroContentExcursionsAccessibilityLevel
    | undefined;
  activityLevel: SanityMicroContentExcursionsActivityLevel | undefined;
  features: SanityMicroContentExcursionsFeature[];
};

const ContentExcursionInfoBox: React.FC<ContentExcursionInfoBoxProps> = ({
  hideDurationAndCode,
  duration,
  activityLevel,
  accessibilityLevel,
  features
}) => {
  return (
    <ExcursionInfoBox>
      {!hideDurationAndCode && !!duration && duration > 0 && (
        <ExcursionInfoBoxItem
          icon="duration"
          label={<Trans>Duration</Trans>}
          value={<Plural value={duration} one="# hour" other="# hours" />}
        />
      )}
      {activityLevel && (
        <ExcursionInfoBoxItem
          icon={
            <ExcursionActivityLevelIcon
              iconStep={activityLevel.iconStep || 0}
            />
          }
          label={<Trans>Activity Level</Trans>}
          value={activityLevel.label}
        >
          {activityLevel.content}
        </ExcursionInfoBoxItem>
      )}

      {accessibilityLevel && accessibilityLevel.icon && (
        <ExcursionInfoBoxItem
          icon={accessibilityLevel.icon as IconName}
          label={<Trans>Accessibility</Trans>}
          value={accessibilityLevel.label}
        >
          {accessibilityLevel.content}
        </ExcursionInfoBoxItem>
      )}
      {features?.map((i, index) => (
        <ExcursionInfoBoxItem
          key={index}
          icon={i.icon as IconName}
          label={i.label || ""}
          value={undefined}
        >
          {i.content}
        </ExcursionInfoBoxItem>
      ))}
    </ExcursionInfoBox>
  );
};

export default ContentExcursionInfoBox;
